import { assetApis } from "../../components/pages/assets/AssetRoutes";
import { deploymentApis } from "../../components/pages/deployments/DeploymentRoutes";
import { locationApis } from "../../components/pages/location/LocationRoute";
import { clampingApis } from "../../components/pages/parking/ClampingRoutes";
import { bookingsApis } from "../../components/pages/parking/ReservationRoutes";
import { streetApis } from "../../components/pages/parking/SmartParkingRoute";
import { adhocSourceApis } from "../../components/pages/reports/adhoc/adhocReportHooks";
import {
  API_ACCOUNTS_PROFILES,
  API_ACCOUNTS_ROLES,
  API_AUDIT_ACTIVITY,
  API_CONFIGURABLES,
  API_DORMANT_ACCOUNTS,
  API_LEDGERS,
  API_NOTIFICATIONS,
  API_PAY_WEEK_CONFIGURATION,
  API_WAGE_ADVANCEMENTS,
  API_FIXED_WAGES,
  API_USERS,
  API_VEHICLE_TYPES_CREATE,
  API_WAGES_BONUS,
  API_WAGES_CONFIGURATIONS,
  API_WEEKLY_COLLECTIONS,
  // API_WAGES_REPORT,
  // API_WEEKLY_COLLECTIONS_STAFF,
  API_REQUISITION,
  API_PETTY_CASH_REQUISITION,
} from "../../utils/apis";
import {
  API_REVENUE_LEDGER_REPORTS,
  DAILY_COLLECTION_BALNCES_API,
  END_OF_DAY_REPORT_API,
} from "../../utils/constants";

export const sourceApis: Record<string, string> = {
  users: API_USERS,
  // ROLES
  roles: API_ACCOUNTS_ROLES,
  // CONFIGURABLES
  configurables: API_CONFIGURABLES,
  vehicle_types: API_VEHICLE_TYPES_CREATE,
  // MASTER DATA APIS
  ...locationApis,

  //STRRET CONFIGURABLES
  ...streetApis,

  //BOOKINGS
  ...bookingsApis,
  dormant_accounts: API_DORMANT_ACCOUNTS,

  //CLAMPING
  ...clampingApis,

  // USER PROFILE
  profile: API_ACCOUNTS_PROFILES,
  ledgers: API_LEDGERS,
  end_of_day_report: END_OF_DAY_REPORT_API,
  daily_collection_balances: DAILY_COLLECTION_BALNCES_API,
  revenue_ledger_report: API_REVENUE_LEDGER_REPORTS,

  //WAGES
  wages_configurations: API_WAGES_CONFIGURATIONS,
  wages_bonus: API_WAGES_BONUS,
  weekly_commissions: API_WEEKLY_COLLECTIONS,
  fixed_wages: API_FIXED_WAGES,
  pay_week_configuration: API_PAY_WEEK_CONFIGURATION,
  wage_advancements: API_WAGE_ADVANCEMENTS,
  staff_wages_requisition: API_REQUISITION,
  petty_cash_requisition: API_PETTY_CASH_REQUISITION,

  //ASSETS
  ...assetApis,

  //DEPLOYMENTS
  ...deploymentApis,

  // AUDIT ACTIVITY
  audit_activity: API_AUDIT_ACTIVITY,
  ...adhocSourceApis,

  //NOTIFICATIONS
  notifications: API_NOTIFICATIONS,
};
